"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceFailedReason = exports.InvoiceStatus = void 0;
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["CREATED"] = "CREATED";
    InvoiceStatus["PENDING"] = "PENDING";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["DONE"] = "DONE";
    InvoiceStatus["FAILED"] = "FAILED";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var InvoiceFailedReason;
(function (InvoiceFailedReason) {
    InvoiceFailedReason["PAYMENT_DECLINED"] = "PAYMENT_DECLINED";
    InvoiceFailedReason["GATEWAY_FAILED"] = "GATEWAY_FAILED";
})(InvoiceFailedReason = exports.InvoiceFailedReason || (exports.InvoiceFailedReason = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW52b2ljZVN0YXR1cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9JbnZvaWNlU3RhdHVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksYUFNWDtBQU5ELFdBQVksYUFBYTtJQUN2QixvQ0FBbUIsQ0FBQTtJQUNuQixvQ0FBbUIsQ0FBQTtJQUNuQiw4QkFBYSxDQUFBO0lBQ2IsOEJBQWEsQ0FBQTtJQUNiLGtDQUFpQixDQUFBO0FBQ25CLENBQUMsRUFOVyxhQUFhLEdBQWIscUJBQWEsS0FBYixxQkFBYSxRQU14QjtBQUVELElBQVksbUJBR1g7QUFIRCxXQUFZLG1CQUFtQjtJQUM3Qiw0REFBcUMsQ0FBQTtJQUNyQyx3REFBaUMsQ0FBQTtBQUNuQyxDQUFDLEVBSFcsbUJBQW1CLEdBQW5CLDJCQUFtQixLQUFuQiwyQkFBbUIsUUFHOUIifQ==